import PreView from './previewImage';
document.addEventListener('turbolinks:load', () => {
  if (!document.body.className.includes('page-topics')) {
    return;
  }
  // 图片加载
  $('.markdown-body .attachment-image').on('load', (e) => {
    e.target.parentElement.classList.add('revert');
  });
  window.preview = new PreView({
    isShowUpload: false
  });
});
